import React, { createContext, useContext, useState } from 'react';

// Create context
const AppContext = createContext();

// Context provider component
export const AppProvider = ({ children }) => {
  const [userImage, setUserImage] = useState(null);
  const [measurements, setMeasurements] = useState(null);
  const [recommendedSize, setRecommendedSize] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedClothing, setSelectedClothing] = useState(null);

  // Log state changes during development
  const loggedSetMeasurements = (data) => {
    console.log("Setting measurements in context:", data);
    setMeasurements(data);
  };

  const loggedSetRecommendedSize = (size) => {
    console.log("Setting recommended size in context:", size);
    setRecommendedSize(size);
  };

  return (
    <AppContext.Provider
      value={{
        userImage,
        setUserImage,
        measurements,
        setMeasurements: loggedSetMeasurements,
        recommendedSize,
        setRecommendedSize: loggedSetRecommendedSize,
        loading,
        setLoading,
        selectedClothing,
        setSelectedClothing,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for using the context
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
// Export the context and provider

